<template>
  <div>
    <h2>Users</h2>
    <v-server-table id="org_table" ref="users_table" :columns="tableColumns" :options="options" @loading="onLoading" @loaded="onLoaded"
                     @row-click="rowClicked">
      <!-- toggle show disabled passes -->
      <b-form slot="beforeTable" v-show="!loading">
        <b-form-group>
          <b-form-checkbox type="checkbox" v-on:change="toggleShowDisabledFacilities()" checked=false>
            Include inactive facilities
          </b-form-checkbox>
        </b-form-group>
      </b-form>

      <!-- checkbox cells -->
      <b-form-checkbox type="checkbox" slot="has_skiing" slot-scope="props" v-model="props.row.has_skiing"
                       disabled></b-form-checkbox>
      <b-form-checkbox type="checkbox" slot="has_non_ski_day" slot-scope="props" v-model="props.row.has_non_ski_day"
                       disabled></b-form-checkbox>
      <b-form-checkbox type="checkbox" slot="enabled" slot-scope="props" v-model="props.row.enabled"
                       disabled></b-form-checkbox>

      <!--edit organisation form -->
      <div slot="child_row" slot-scope="props">
        <form @submit.prevent="edit(props.row)">
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <div v-if="isAdmin">
                <label for="org_edit_name">Organisation Name</label>
                <b-form-input type="text" id="org_edit_name" v-model="props.row.name" required></b-form-input>
              </div>

              <label for="org_edit_full_name">Name</label>
              <b-form-input type="text" id="org_edit_full_name" v-model="props.row.full_name"></b-form-input>
              <label for="org_edit_username">Username</label>
              <b-form-input type="text" id="org_edit_username" v-model="props.row.username"></b-form-input>
              <label for="org_edit_email">Email</label>
              <b-form-input type="email" id="org_edit_email" v-model="props.row.email"></b-form-input>
              <b-form-group>
                <b-form-checkbox id="org_edit_has_skiing" v-model="props.row.has_skiing">Has skiing
                </b-form-checkbox>
                <b-form-checkbox id="org_edit_has_non_ski_day" v-model="props.row.has_non_ski_day">
                  Has non ski day
                </b-form-checkbox>
              </b-form-group>
              <b-form-group>
                <div v-if="isAdmin">
                  <b-form-checkbox v-on:change="showOrgDeletionWarning(props.row.enabled)" type="checkbox"
                                  id="org_edit_enabled" v-model="props.row.enabled">
                    Organisation active
                  </b-form-checkbox>
                </div>
              </b-form-group>
              <b-form-group>
                <b-form-checkbox id="org_edit_send_email" v-model="props.row.send_email">Send password reset email
                </b-form-checkbox>
              </b-form-group>
              <b-alert variant="danger"
                       dismissible
                       :show="showDismissibleAlert"
                       @dismissed="showDismissibleAlert=false">
                Beware: disabling a facility will make it disappear from this page unless you check "Include inactive facilities"!
              </b-alert>
              <b-alert variant="success" :show="password_reset_email_sent">Successfully sent password reset email!
              </b-alert>
              <b-form-group>
                <b-button type="submit">Submit</b-button>
                <b-button type="button" @click="deleteUser(props.row.id)">Delete</b-button>
              </b-form-group>
            </div>
          </div>
        </form>
      </div>
      <!-- create facility form -->
      <template v-slot:afterBody class="">
        <tr>
        <td class="" v-if="isAdmin">
          <multiselect class="multiselect" :multiple="false" label="text" track-by="value" :taggable="true"
                       @tag="addTag" v-model="selected" :options="organisation_options"></multiselect>
        </td>
        <td class="">
          <b-form-input v-model="createdOrganisation.full_name" placeholder="new user's full name"></b-form-input>
        </td>
        <td class="">
          <b-form-input v-model="createdOrganisation.username" placeholder="new user's username"></b-form-input>
        </td>
        <td class="">
          <b-form-input type="email" v-model="createdOrganisation.email" placeholder="new user's email"></b-form-input>
        </td>
        <td class="">
          <b-form-checkbox checked="false" v-model="createdOrganisation.has_skiing"></b-form-checkbox>
        </td>
        <td class="">
          <b-form-checkbox checked="true" v-model="createdOrganisation.has_non_ski_day"></b-form-checkbox>
        </td>
        <td class="">
          <b-form-checkbox checked="true" v-model="createdOrganisation.manage_own_passes"></b-form-checkbox>
        </td>
        <td>
          <b-button type="save" v-on:click="createOrganisationUser()">Create</b-button>
        </td>
        </tr>

       <tr colspan=8>
          <b-alert variant="success"
                   :show="successDismissCountDown"
                   dismissible
                   @dismissed="successDismissCountDown=0"
                   @dismiss-count-down="successCountDownChanged">Successfully created user
          </b-alert>
          <b-alert :show="errorDismissCountDown"
                   dismissible
                   variant="warning"
                   @dismissed="errorDismissCountDown=0"
                   @dismiss-count-down="errorCountDownChanged">
            {{ errorMessage}}
          </b-alert>
          </tr>
  
        
      <div v-if="loading">
        <div class="overlay-loader"></div>
        <icon scale="1" name="spinner" spin class="clip-loader"></icon>
      </div>
      </template>
      
    </v-server-table>
  </div>
</template>

<script>
  import api from '../api'
  import Multiselect from 'vue-multiselect'

  var showDisabledFacilities = false;
  var lastOpenedChildRow = null;
  var defaultCreatedOrganisation = {
    name: '',
    full_name: '',
    username: '',
    email: '',
    has_skiing: 'true',
    has_non_ski_day: 'false',
    enabled: 'true',
    manage_own_passes: 'false'
  };

  export default {
    name: "Users",
    components: {
      Multiselect
    },
    data() {
      return {
        columns: ['id', 'name', 'full_name', 'username', 'email', 'has_skiing', 'has_non_ski_day', 'enabled', 'manage_own_passes'],
        data: [],
        options: {
          headings: {
            id: 'ID',
            name: 'Organisation Name',
            full_name: 'Name',
            username: 'Username',
            email: 'Email',
            has_skiing: 'Skiing',
            has_non_ski_day: 'Non ski day',
            enabled: 'Active',
            manage_own_passess: 'Manage Own Passes'
          },
          perPage: 25,
          sortable: ['name',],
          filterable: ['name'],
          requestFunction: function (data) {
            data.show_disabled_facilities = showDisabledFacilities
            return api.getAllOrganisationUsers(data)
              .then(res => {
                this.loading = false;
                return res;
            })
              .catch(function (e) {
                this.dispatch('error', e);
              }.bind(this));
          },
          responseAdapter(response) {
            return {
              data: response.data.ret_msg,
              count: response.data.ret_msg.length > 0 ? response.data.ret_msg[0].full_count : 0
            }
          }
        },
        events: {},
        loading: false,
        showDismissibleAlert: false,
        password_reset_email_sent: false,
        showOrganisationCreated: false,
        errorDismissSecs: 5,
        errorDismissCountDown: 0,
        successDismissSecs: 5,
        successDismissCountDown: 0,
        errorMessage: '',
        createdOrganisation: JSON.parse(JSON.stringify(defaultCreatedOrganisation)),
        selected: {},
        organisation_options: [],
        isAdmin: api.userIsAdmin()
      }
    },
    async mounted() {
      const orgResponse = await api.getAllOrganisationNames();
      this.organisation_options = orgResponse.data.ret_msg;
      this.selected = this.organisation_options[1]
      this.loading = false;
    },
    methods: {
      onLoading(event) {
        this.loading = true;
      },
      onLoaded(event) {
        this.loading = false;
      },
      rowClicked(event) {
        var current_id = event.row.id
        if (lastOpenedChildRow && lastOpenedChildRow != current_id) {
          this.$refs.users_table.toggleChildRow(lastOpenedChildRow);
        }

        this.$refs.users_table.toggleChildRow(current_id);
        lastOpenedChildRow = (lastOpenedChildRow == current_id) ? null : current_id
      },
      edit(row) {
        this.loading = true;
        var that = this
        var org_table = this.$refs.users_table;
        api.updateOrganisationUser(row.id, row.org_id, row.enabled, row.name, row.full_name, row.username, row.email, row.has_skiing, row.has_non_ski_day).then(function (response) {
          org_table.refresh();
          if (row.send_email) {
            api.resetPassword(row.email).then(function (result) {
              row.email_success = true;
              that.password_reset_email_sent = true;
              setTimeout(function () {
                that.password_reset_email_sent = false;
              }, 4000);

            })
          }
        });
      },
      deleteUser(id) {
        console.log("Deleting user with id: " + id);
        this.loading = true;
        var that = this
        that.loading = true;
        api.deleteUser(id).then(function (response) {
          that.$refs.users_table.refresh();
          that.loading = false;
        });
      },
      showOrgDeletionWarning(previouslyEnabled) {
        if (previouslyEnabled) {
          this.showDismissibleAlert = true;
        } else {
          this.showDismissibleAlert = false;
        }
      },
      errorCountDownChanged(errorDismissCountDown) {
        this.errorDismissCountDown = errorDismissCountDown
      },
      showAlert() {
        this.errorDismissCountDown = this.errorDismissSecs
        this.loading = false
      },
      successCountDownChanged(successDismissCountDown) {
        this.successDismissCountDown = successDismissCountDown
      },
      showSuccess() {
        this.successDismissCountDown = this.successDismissSecs
      },
      async createOrganisationUser() {
        this.loading = true
        this.createdOrganisation.name = this.selected.text
        if (this.createdOrganisation.name.length < 4) {
          this.errorMessage = 'Please enter a name for the facility';
          this.showAlert();
          return;
        }

        if (this.createdOrganisation.full_name.length < 4) {
          this.errorMessage = 'Please enter the new user\'s full name';
          this.showAlert();
          return;
        }

        if (this.createdOrganisation.username.length < 4) {
          this.errorMessage = 'Please enter the new user\'s username';
          this.showAlert();
          return;
        }

        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(this.createdOrganisation.email.toLowerCase())) {
          this.errorMessage = 'Please enter a valid email address for the new user';
          this.showAlert();
          return;
        }

        try {
          if (this.isAdmin) {
            const organisation = await api.createOrganisationAccount(this.createdOrganisation);
            this.createdOrganisation.org_id = organisation.data.ret_msg[0].id;
          }

          await api.createUserAccount(this.createdOrganisation);
          this.createdOrganisation = JSON.parse(JSON.stringify(defaultCreatedOrganisation));
          this.$refs.users_table.refresh();
          this.loading = false
          this.showSuccess()
        } catch (e) {
          console.log(e);
          if (e.response.data == undefined) {
            this.errorMessage = "An unknown error occurred"
          } else {
            this.errorMessage = e.response.data.ret_msg || this.errorMessage;
            this.loading = false
            this.showAlert();
          }
        }
      },
      toggleShowDisabledFacilities() {
        showDisabledFacilities = !showDisabledFacilities
        this.$refs.users_table.refresh()
      },
      addTag(newTag) {
        const tag = {
          text: newTag,
          value: null
        }
        this.organisation_options.push(tag)
        this.createdOrganisation.name = newTag
        this.selected = tag
      }
    },
    computed: {
      tableColumns() {
        const columns = ['full_name', 'username', 'email', 'has_skiing', 'has_non_ski_day', 'enabled'];

        return this.isAdmin ? ['name', ...columns] : columns; 
      }
    }
  }
</script>

<style>
  table {
    width: 100%;
    position: relative;
  }

  .overlay-loader {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    opacity: 0.8;
    filter: blur(5px);
  }

  .clip-loader {
    position: absolute;
    left: 50%;
    right: 50%;
    bottom: 60%;
    top: 40%;
    width: 60px;
    height: 60px;
  }

  /* hide child row toggler column, otherwise child rows can reach an inconsistent open state */
  #org_table tbody > tr:not(.VueTables__child-row) > td:first-child, #org_table thead > tr > th:first-child {
    display: none;
  }

  #org_table tbody tr {
    cursor: pointer;
  }

  #org_table .table-responsive {
    overflow-y: -webkit-paged-y;;
  }
</style>






// WEBPACK FOOTER //
// src/components/Users.vue